import { render, staticRenderFns } from "./BlogNav.vue?vue&type=template&id=4149fe48&scoped=true&"
import script from "./BlogNav.vue?vue&type=script&lang=js&"
export * from "./BlogNav.vue?vue&type=script&lang=js&"
import style0 from "./BlogNav.vue?vue&type=style&index=0&id=4149fe48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4149fe48",
  null
  
)

export default component.exports